import React, { Component } from "react";
import {
  Box,
  Breadcrumbs,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtBtn from "./CustomTool/CtBtn";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtDtp from "./CustomTool/CtDtp";
import CtTxt from "./CustomTool/CtTxt";
import CtART from "./CustomTool/ResponsiveTable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import Link from "@mui/material/Link";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapSetUserPrivileges_ToProps,
} from "../mapRedux/mapReduxProps";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CallIcon from "@mui/icons-material/Call";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { withRouter } from "../HOC/withRouter";
import "./AMCList.css";
import { connect } from "react-redux";
import AMCNewEntry from "./AMCNewEntry";
import { useNavigate } from "react-router-dom";
import ImportAMC from "./ImportAMC";
import AMCFilter from "./AMCFilter";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";

class AMCList extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "branchName",
        header: "Branch Name",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 120,
      },
      {
        accessorKey: "siteName",
        header: "Site Name",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 200,
      },
      {
        accessorKey: "documentNo",
        header: "Document No.",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 200,
      },
      {
        accessorKey: "contractType",
        header: "Contract Type",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 130,
      },
      {
        accessorKey: "totalLift",
        header: "Total Lift",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 90,
      },
      {
        accessorKey: "totalAmount",
        header: "Total Amount",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 120,
      },
      {
        accessorKey: "paymentType",
        header: "Payment Type",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 130,
      },
      {
        accessorKey: "contractStage",
        header: "Contract Stage",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 130,
      },
    ],
    rows: [
      {
        id: 1,
        branchName: "Bhavnagar",
        siteName: "Aarohi Complex",
        documentNo: "TOP/AMC/BVN/25-26/03",
        contractType: "Popular",
        totalLift: 2,
        totalAmount: "1,00,000",
        paymentType: "Advance",
        contractStage: "Follow Up",
      },
      {
        id: 2,
        branchName: "Bhavnagar",
        siteName: "Rashi Complex",
        documentNo: "TOP/AMC/BVN/25-26/06",
        contractType: "Regular",
        totalLift: 4,
        totalAmount: "2,00,000",
        paymentType: "After Service",
        contractStage: "Final",
      },
    ],
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(new Date()),
      dtptoDate: get_YMD_from_SYS(new Date()),
      branch: "",
      type: "",
    },
    branchOptions: [{ value: "Bhavnagar" }],
    TypeData: [
      { value: "All" },
      { value: "Incomplete" },
      { value: "Submitted" },
      { value: "Done" },
      { value: "Lost" },
    ],
    dataLoadStatus: true,
    // importForm: this.getDefaultImportForm(),
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    moreMenuAnchorEl: null,
    moreMenuRow: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "Top India Elevator : AMC List";
    localStorage.setItem("Heading", "AMC List");

    document.getElementById("dtpFromDate").focus();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  /* ---------- FILTER HANDLERS ---------- */
  // handleFilterChange = (field, value) => {
  //   this.setState((prev) => ({
  //     filters: {
  //       ...prev.filters,
  //       [field]: value,
  //     },
  //   }));
  // };

  /* ---------- ENTRY FORM HANDLERS ---------- */
  handleEntryChange = (field, value) => {
    this.setState((prev) => ({
      entryForm: {
        ...prev.entryForm,
        [field]: value,
      },
    }));
  };

  handleOnNewEntryClick = () => {
    this.setState({ ARD: null }, () => {
      const ARD = (
        <AlertResponsiveDialog
          labelAgree=""
          labelDisagree="Close"
          alertMessage={<AMCNewEntry />}
          actionAlign="flex-end"
          handleOnClickNo={() => this.setState({ ARD: null })}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleOnImportClick = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree=""
          labelDisagree="Close"
          alertMessage={<ImportAMC />}
          actionAlign="flex-end"
          handleOnClickNo={() => this.setState({ ARD: null })}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleTableEditClick = (rtRow) => {
    this.props.navigateTo("AMCRegistration", { editData: rtRow?.original });
  };

  handleTableViewClick = (rtRow) => {
    console.log("AMC row:", rtRow?.original);
  };

  handleMoreMenuOpen = (rtRow, event) => {
    this.setState({
      moreMenuAnchorEl: event.currentTarget,
      moreMenuRow: rtRow?.original || null,
    });
  };

  handleMoreMenuClose = () => {
    this.setState({ moreMenuAnchorEl: null, moreMenuRow: null });
  };

  handleMoreMenuAction = (actionKey) => {
    const { moreMenuRow } = this.state;
    this.setState({ moreMenuAnchorEl: null, moreMenuRow: null }, () => {
      console.log("More action:", actionKey, "Row:", moreMenuRow);
    });
  };

  handleOnFilterClick = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree=""
          labelDisagree="Close"
          alertMessage={<AMCFilter />}
          actionAlign="flex-end"
          handleOnClickNo={() => this.setState({ ARD: null })}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  //#endregion handle

  //region function

  //#endregion handle

  render() {
    return (
      <form>
        <Box className="amc-list-page">
          {/* <Typography className="amc-breadcrumb">
            <span
              className="amc-breadcrumb-link"
              onClick={() => this.props.navigateTo("Dashboard")}
            >
              Dashboard
            </span>{" "}
            / AMC Dashboard / <strong>AMC List</strong>
          </Typography>

          <Typography variant="h4" className="amc-title">
            AMC List
          </Typography> */}

          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/#/Dashboard">
              Dashboard
            </Link>
            <Link underline="hover" color="inherit" href="/#/AMCDashboard">
              AMC Dashboard
            </Link>
            <Typography sx={{ color: "text.primary" }}>AMC List</Typography>
          </Breadcrumbs>

          <Typography fontSize={25} fontWeight={400} className="amc-title">
            AMC List
          </Typography>

          {/* ---------- FILTER ROW ---------- */}
          <Grid
            container
            spacing={2}
            alignItems="flex-end"
            marginTop={0}
            className="amc-filter-row"
          >
            <Grid item>
              <CtDtp
                id="dtpFromDate"
                label="From Date*"
                width="150"
                handleOnChange={this.handleOnChange}
                // defaultValue={this.state.formData.dtpFromDate}
                value={this.state.formData.dtpFromDate}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"dtpToDate"}
                // accountYear={localStorage.getItem("ACY")}
              />
            </Grid>

            <Grid item>
              <CtDtp
                id="dtpToDate"
                label="To Date*"
                width="150"
                handleOnChange={this.handleOnChange}
                // defaultValue={this.state.formData.dtpToDate}
                value={this.state.formData.dtptoDate}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"branch"}
                // accountYear={localStorage.getItem("ACY")}
              />
            </Grid>

            <Grid item>
              <CtCmbEditable
                id="branch"
                label="Branch"
                items={this.state.branchOptions}
                handleOnChange={this.handleOnChange}
                width={180}
                maxLength={100}
                colID="value"
                value={this.state.formData.branch}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"type"}
              />
            </Grid>

            <Grid item>
              <CtCmbEditable
                id="type"
                label="Type"
                items={this.state.TypeData}
                handleOnChange={this.handleOnChange}
                width={180}
                maxLength={100}
                colID="value"
                value={this.state.formData.type}
                onKeyDown={this.props.onKeyDown}
                defaultAction={() => window.location.reload()}
              />
            </Grid>

            <Grid item>
              <CtBtn
                label="LOAD"
                iconName="load"
                firstletterBig={false}
                className="secondary-button"
                width={110}
                onClick={() => window.location.reload()}
              />
            </Grid>

            <Grid item>
              <CtBtn
                label="FILTER"
                iconName="filter"
                variant="outlined"
                firstletterBig={false}
                className="child-button"
                width={110}
                onClick={this.handleOnFilterClick}
              />
            </Grid>
          </Grid>

          {/* ---------- ACTION BUTTONS ---------- */}
          <Grid
            container
            spacing={2}
            marginTop={1}
            alignItems="flex-end"
            className="amc-action-row"
          >
            <Grid item>
              <CtBtn
                label="New AMC Entry"
                iconName="new"
                firstletterBig={false}
                className="secondary-button"
                onClick={this.handleOnNewEntryClick}
              />
            </Grid>
            <Grid item>
              <CtBtn
                label="Existing AMC"
                iconName="new"
                firstletterBig={false}
                className="secondary-button"
                onClick={() =>
                  this.props.navigateTo("ContractDetail", {
                    contract: "Existing AMC",
                  })
                }
              />
            </Grid>
            <Grid item>
              <CtBtn
                label="IMPORT"
                iconName="import"
                firstletterBig={false}
                className="secondary-button"
                onClick={this.handleOnImportClick}
              />
            </Grid>
          </Grid>

          <Grid className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={25}
              tblmaxHeight={460}
              csvFileName={"AMCList"}
              showColumnFilters={false}
              actionColSize={80}
              density={"compact"}
              hideBottomToolbar={true}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleTableEditClick,
                  className: "secondary-button",
                },
                {
                  label: "More",
                  onClick: this.handleMoreMenuOpen,
                  className: "secondary-button",
                },
              ]}
            />
          </Grid>
          <Menu
            anchorEl={this.state.moreMenuAnchorEl}
            open={Boolean(this.state.moreMenuAnchorEl)}
            onClose={this.handleMoreMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={() => this.handleMoreMenuAction("print")}>
              <ListItemIcon>
                <PrintIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Print</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("pdf")}>
              <ListItemIcon>
                <PictureAsPdfIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>PDF</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("revise")}>
              <ListItemIcon>
                <ContentCopyIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Revise</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={() => this.handleMoreMenuAction("edit-contract")}
            >
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Edit Contract</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("final")}>
              <ListItemIcon>
                <CheckCircleOutlineIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Final</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("whatsapp")}>
              <ListItemIcon>
                <WhatsAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Whats App</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("follow-up")}>
              <ListItemIcon>
                <CallIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Follow Up</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("lost")}>
              <ListItemIcon>
                <ThumbDownAltIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Lost</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("delete")}>
              <ListItemIcon>
                <DeleteIcon fontSize="small" color="error" />
              </ListItemIcon>
              <ListItemText>Delete</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("mail")}>
              <ListItemIcon>
                <MailOutlineIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Mail</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => this.handleMoreMenuAction("receipt")}>
              <ListItemIcon>
                <ReceiptLongIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Receipt</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

// export default connect(
//   mapStatetoProps,
//   mapSetActiveMenu_MenuVisibility_ToProps,
// )(HOCVerifyIsUser(HoCtToastContainer(withRouter(AMCList))));
function WithNavigate(props) {
  let navigate = useNavigate();
  return <AMCList {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
